export interface GeoPlace {
  id: string;
  name: string;
  socr?: string;
  index?: string;
}

export interface GeoPlaceRespons {
  count: number;
  item: GeoPlace[];
  page: number;
  total: number;
  totalPage: number;
}

export interface GeoPlacesHook {
  type: string;
  parentId?: string;
  prefix: string;
  isRu: boolean;
}

const fetchGeoPlaces = async (
  params?: Record<string, string>
): Promise<GeoPlace[]> => {
  const url = "/internal-api/geo/places";

  const queryParams = params ? new URLSearchParams(params) : "";
  const fullUrl = `${url}${queryParams ? `?${queryParams}` : ""}`;

  try {
    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.items;
  } catch (error) {
    console.error("Ошибка при получении геоданных:", error);
    return [];
  }
};

export default fetchGeoPlaces;
